import React from 'react';
import ShieldIcon from '../shieldIcon/ShieldIcon';

const PALETTE = { color: '#a3670f', backgroundColor: '#fbf1e2', borderColor: '#e7c88c' };

const DEFAULT_TITLE = 'Created via partner integration — editing its campaigns needs confirmation first.';

// Pill badge for a partner-created client, shared by the Client Explorer table
// (dataTable.jsx) and the Client Edit page's Integration panel so both surfaces
// agree on the same copy and colour language. There's a single state - per PR
// review on STP-168's backend half, there's no permanent guard-bypass flag to
// reflect here, so this never varies.
const PartnerBadge = ({ title }) => (
  <span
    title={title || DEFAULT_TITLE}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      fontSize: 12,
      fontWeight: 600,
      padding: '3px 10px 3px 8px',
      borderRadius: 999,
      border: `1px solid ${PALETTE.borderColor}`,
      color: PALETTE.color,
      backgroundColor: PALETTE.backgroundColor
    }}
  >
    <ShieldIcon />
    Partner-created
  </span>
);

export default PartnerBadge;
